import type { AppConfig } from './base';
import { AppConfigSchema } from './base';

export function createConfig(): AppConfig {
  let unparsedEnv: Record<string, unknown>;

  if (useWindowsEnv()) {
    unparsedEnv = window.__ENV__;
  } else {
    unparsedEnv = import.meta.env;
  }

  const withoutVitePrefix = stripVitePrefix(unparsedEnv);

  const config = AppConfigSchema.safeParse(withoutVitePrefix);

  if (!config.success) {
    throw new Error(`Couldn't create app config!\n${JSON.stringify(config.error, null, 2)}`);
  }

  return config.data;
}

function useWindowsEnv() {
  return typeof window !== 'undefined' && typeof window.__ENV__ === 'object' &&
    !Object.values(window.__ENV__).some(s => typeof s === 'string' && s.startsWith('$VITE_'));
}

function stripVitePrefix(env: Record<string, unknown>): Record<string, unknown> {
  const strippedEnv: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(env)) {
    if (key.startsWith('VITE_')) {
      strippedEnv[key.slice(5)] = value;
    } else {
      strippedEnv[key] = value;
    }
  }
  return strippedEnv;
}

let configInstance: AppConfig;
export function config(): AppConfig {
  if (configInstance) return configInstance;

  configInstance = createConfig();

  return configInstance;
}